/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Detail-page summary cards (034 US6) for ONE pinned user's filtered workout records,
 * on the shared au-card system: Total Records, distinct Workout Types, and Duration
 * stats (total + average, formatted h/m/s). Derived from the same filtered set so they
 * reconcile with the table. Average shows "—" on an empty set (no divide-by-zero).
 *
 * Props: { totalRecords, distinctTypes, totalDurationMs, avgDurationMs }
 * (avgDurationMs may be null → rendered as "—")
 */
const n = (v) => Number(v || 0).toLocaleString();

// Milliseconds → human-readable h/m/s (mirrors WorkoutDetailList's formatDuration).
export const formatDuration = (ms) => {
  if (ms == null) return '—';
  const totalSeconds = Math.floor(Number(ms) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);
  return parts.join(' ');
};

const WorkoutDetailSummaryCards = ({
  totalRecords = 0,
  distinctTypes = 0,
  totalDurationMs = 0,
  avgDurationMs = null,
}) => (
  <div className="au-cards" data-testid="wk-detail-summary">
    <div className="au-card">
      <span className="au-card__label">Total Records</span>
      <span className="au-card__value tnum">{n(totalRecords)}</span>
    </div>
    <div className="au-card">
      <span className="au-card__label">Workout Types</span>
      <span className="au-card__value tnum">{n(distinctTypes)}</span>
      <span className="au-card__sub">distinct types</span>
    </div>
    <div className="au-card">
      <span className="au-card__label">Total Duration</span>
      <span className="au-card__value tnum">{formatDuration(totalDurationMs)}</span>
    </div>
    <div className="au-card">
      <span className="au-card__label">Average Duration</span>
      <span className="au-card__value tnum">{avgDurationMs == null ? '—' : formatDuration(avgDurationMs)}</span>
      <span className="au-card__sub">per record</span>
    </div>
  </div>
);

export default WorkoutDetailSummaryCards;
